import { Link } from 'react-router-dom'

const MANDALA_DOTS = [
  { cx: 100, cy: 10 },
  { cx: 184, cy: 70 },
  { cx: 16, cy: 130 },
  { cx: 150, cy: 168 },
  { cx: 50, cy: 32 },
  { cx: 186, cy: 118 },
  { cx: 14, cy: 82 },
]

export default function GalleryHeroSection({
  breadcrumbs = [{ label: 'Home', to: '/' }, { label: 'Gallery' }],
  eyebrow = 'Sacred Visuals',
  title = <>Divine Media <span className="text-gradient-gold">Gallery</span></>,
  subtitle = 'Teachings, discourses and spiritual insights from Maharaj Ji — captured for every seeker.',
}) {
  return (
    <div className="relative overflow-hidden bg-primary text-white pt-35 pb-16">
      <div aria-hidden="true" className="absolute inset-0 bg-linear-to-b from-[#3a0a14] via-primary to-[#2a0710]" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(55%_70%_at_50%_0%,rgba(232,119,15,0.20),transparent_70%)]" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(45%_55%_at_100%_100%,rgba(232,119,15,0.10),transparent_70%)]" />

      <div
        aria-hidden="true"
        className="absolute -right-16 top-1/2 -translate-y-1/2 w-[24rem] h-96 opacity-[0.10] animate-[spin_140s_linear_infinite] motion-reduce:animate-none flex items-center justify-center pointer-events-none"
      >
        <span className="text-[170px] text-[#E6C878] select-none">ॐ</span>
      </div>
      <svg
        aria-hidden="true"
        className="absolute -right-8 top-1/2 -translate-y-1/2 w-md h-md opacity-[0.14] animate-[spin_260s_linear_infinite_reverse] motion-reduce:animate-none pointer-events-none"
        viewBox="0 0 200 200"
        fill="none"
        stroke="#E6C878"
      >
        <circle cx="100" cy="100" r="94" strokeWidth="0.4" />
        <circle cx="100" cy="100" r="10" strokeWidth="0.8" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(60 100 100)" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(120 100 100)" />
        {MANDALA_DOTS.map((dot) => (
          <circle key={`${dot.cx}-${dot.cy}`} cx={dot.cx} cy={dot.cy} r="2.4" fill="#E6C878" stroke="none" fillOpacity="0.7" />
        ))}
      </svg>

      <div className="container px-6 mx-auto relative z-10">
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[10px] uppercase tracking-[0.2em] text-white/40 mb-7">
          {breadcrumbs.map((crumb, i) => (
            <span key={crumb.label} className="flex min-w-0 items-center gap-2">
              {i > 0 && <span className="opacity-40 shrink-0">/</span>}
              {crumb.to ? (
                <Link to={crumb.to} className="hover:text-secondary transition-colors">{crumb.label}</Link>
              ) : (
                <span className="text-secondary truncate">{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>

        <div className="max-w-2xl">
          <div className="hero-chip mb-5 inline-flex">
            <span className="text-secondary">✦</span> {eyebrow}
          </div>
          <h1 className="text-4xl md:text-5xl font-cinzel leading-tight uppercase">
            {title}
          </h1>
          <p className="text-white/50 text-sm mt-3 max-w-xl">
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  )
}
